import {feedback, location, machine, product, documents, troubleshooting} from './bd'

export const bdService = {
  getAuthenticationNumber: feedback.getAuthenticationNumber,
  retrievePassword: feedback.retrievePassword,
  fetchFeedback: feedback.fetchFeedback,
  sendFeedback: feedback.sendFeedback,
  updateFeedback: feedback.updateFeedback,
  fetchFaultCodes: machine.fetchFaultCodes,
  fetchMachineData: machine.fetchMachineData,
  fetchMachinePassword: product.fetchMachinePassword,
  updateMachinePassword: product.updateMachinePassword,
  fetchFieldMods: machine.fetchFieldMods,
  getWarrantyPlans: machine.getWarrantyPlans,
  fetchWarrantyInclusions: machine.fetchWarrantyInclusions,
  getBuiltOptions: machine.getBuiltOptions,
  fetchSubscription: machine.fetchSubscription,
  fetchLocationHistory: location.fetchLocationHistory,
  fetchLastKnownLocation: location.fetchLastKnownLocation,
  fetchSchematics: documents.fetchSchematics,
  fetchSchematicDetails: documents.fetchSchematicDetails,
  fetchDocuments: documents.fetchDocuments,
  fetchDocumentDownloadLink: documents.fetchDocumentDownloadLink,
  fetchManuals: documents.fetchManuals,
  fetchServiceLetters: documents.fetchServiceLetters,
  fetchTroubleshootingGuides: troubleshooting.fetchTroubleshootingGuides,
  fetchTroubleshootingSessionList: troubleshooting.fetchTroubleshootingSessionList,
  troubleshootingSessionStart: troubleshooting.troubleshootingSessionStart,
  troubleshootingSessionResume: troubleshooting.troubleshootingSessionResume,
  troubleshootingSessionSummary: troubleshooting.troubleshootingSessionSummary,
  troubleshootingSessionSummaryPDF: troubleshooting.troubleshootingSessionSummaryPDF,
  fetchDetails: product.fetchDetails,
  fetchFaultCodesAutocomplete: product.fetchFaultCodesAutocomplete,
  fetchMaintenanceSchedule: product.fetchMaintenanceSchedule,
  fetchSoftware: documents.fetchSoftware,
  fetchProductSoftware: product.fetchSoftware,
  validateSerial: product.validateSerial,
  fetchBulletins: product.fetchBulletins
}
